import { render, staticRenderFns } from "./SolicitationTagComponent.vue?vue&type=template&id=a948b154&scoped=true&"
import script from "./SolicitationTagComponent.vue?vue&type=script&lang=js&"
export * from "./SolicitationTagComponent.vue?vue&type=script&lang=js&"
import style0 from "./SolicitationTagComponent.vue?vue&type=style&index=0&id=a948b154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a948b154",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VChip,VCol,VIcon,VSheet})
